// reducers/simulationReducer.js

const initialState = {
  isFixed: false,
  selectedBranch: null,
  isFromStandaloneView: true,
  isopenfromAffectedSimList: false,
  selectedTagList: [],
  newSnapshotId: null,
  isAuiViewsAllow: false,
  isSalesCycle: false,
  simType: 'Normal',
  department: null,
  bottomFieldCount: 0,
  defSaveObj: {},
  mpstate: null,
  chartFilterDates: [],
  isallsimulatemodal: false,
  isRTL: false,
  dmode: false,
  loadedTagsList: [],
  openOneCategory: null,
  haveChnagesinCat: false,
  signedobj: {},
  isDirectSimulation: true,
}

// Reducer
export default function simulationReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_SIMULATION_STATE':
      return {
        ...state,
        ...action.payload, // merge updates
      }
    default:
      return state
  }
}

// Action creator
export const setSimulationState = (payload) => ({
  type: 'SET_SIMULATION_STATE',
  payload,
})
